// routes.js — route del Pannello Assistenza (dev/support tecnico). Path/parent
// configurabili; beforeEnter iniettabile (protezione interna, indipendente dalle guard host).
import FeedbackPanelPage from "./views/FeedbackPanelPage.vue";

export const makeFeedbackPanelRoute = ({
  path = "feedback",
  beforeEnter = null,
} = {}) => ({
  path,
  name: "feedback-panel",
  component: FeedbackPanelPage,
  ...(beforeEnter ? { beforeEnter } : {}),
  meta: {
    breadcrumb: "Pannello Assistenza",
    requiresAuth: true,
    requiresPanelAccess: true,
  },
});

export const feedbackPanelRoute = makeFeedbackPanelRoute();

// Alias legacy DEPRECATO. Attenzione alla semantica:
//  - "admin" qui = supporto/dev TECNICO del modulo Assistenza, NON l'admin del CRM cliente;
//  - l'accesso resta deciso SEMPRE da canAccessPanel (beforeEnter interno), mai da isAdmin.
export const feedbackAdminRoute = feedbackPanelRoute;

export default feedbackPanelRoute;
